module.exports = __webpack_public_path__ + "img/lazy.1f42f922.jpg";